import _extends from "@babel/runtime/helpers/esm/extends";
import base from './base';
import { createCdnFont } from './helpers';
var fonts = createCdnFont('https://markup.nieuwsblad.be', ['v1.0.1'], 'v1.0.1');
export default {
  cdn: _extends({}, base.cdn, {
    fonts: fonts
  })
};